const TABLE_HEADER_HEIGHT = 40;
const TABLE_ROW_HEIGHT = 36; // prev value 28 with font 13(not 16), and after 30
const HEADER_BODY_MARGIN = 4;

// const CONNECTOR_WIDTH = 25;
// const CONNECTOR_WIDTH = 28;
const CONNECTOR_WIDTH = 34;

// const LEFT = 'left';
const RIGHT = 'right';

function getLineColor(color = null) {
    // let headerColor;
    let lineColor;

    switch (color) {
        case 'blue': {
            // headerColor = '#031c39'; // #011833b9
            // bodyColor = '#05274e';
            lineColor = '#1c86ff';
            lineColor = 'rgba(89, 137, 250, 1)';
            break;
        }
        case 'green': {
            // headerColor = '#012b22';
            // bodyColor = '#003f31';

            // from Red/Green View
            // headerColor = '#002e28';
            // bodyColor = '#003931';
            lineColor = '#00b69e';
            break;
        }
        case 'orange': {
            // headerColor = '#451d01'; // //562605 662e09
            // bodyColor = '#6a2c03';
            lineColor = '#6a2c03';
            break;
        }
        case 'yellow': {
            // headerColor = '#573900';
            // bodyColor = '#6d4700'; //ad7000
            lineColor = '#6d4700'; //ad7000
            break;
        }
        case 'pink': {
            // headerColor = '#660928';
            // bodyColor = '#7e1b3c';
            lineColor = '#7e1b3c';
            break;
        }
        case 'purple': {
            // headerColor = '#220131';
            // bodyColor = '#320149';
            // lineColor = '#9100d4';
            lineColor = '#8a16ff';
            lineColor = '#a952ffff';
            lineColor = '#bd7bff';

            break;
        }
        case 'violet': {
            // headerColor = '#350235';
            // bodyColor = '#490149';
            lineColor = '#eb03eb';
            break;
        }
        case 'red': {
            // headerColor = '#440813';
            // bodyColor = '#5b1623';

            // from Red/Green View
            // headerColor = '#47021f';
            // bodyColor = '#550225';
            lineColor = '#e80362';
            break;
        }
        case 'default': {
            lineColor = '#e6e6e6';
            break;
        }
        default:
            lineColor = '#e6e6e6';
            break;
    }

    return lineColor;
}

function getConnectorSymbolLines(connector, type, direction) {
    let lines = [];

    switch (type) {
        case 'empty':
            lines = getSymbolEmptyLines(connector, direction);
            break;
        case 'one':
            lines = getSymbolOneLines(connector, direction);
            break;
        case 'many':
            lines = getSymbolManyLines(connector, direction);
            break;
        case 'one-null':
            lines = getSymbolOneNullLines(connector, direction);
            break;
        case 'many-null':
            lines = getSymbolManyNullLines(connector, direction);
            break;
        default:
            break;
    }

    return lines;
}

function getSymbolEmptyLines(connector, direction) {
    const lines = [];

    if (direction === RIGHT) {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y },
            p2: { x: connector.p2.x, y: connector.p2.y },
        });
    } else {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y },
            p2: { x: connector.p2.x, y: connector.p2.y },
        });
    }

    return lines;
}

function getSymbolOneLines(connector, direction) {
    const lines = [];

    if (direction === RIGHT) {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x + 18, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x + 18, y: connector.p1.y + 8 },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y },
            p2: { x: connector.p2.x, y: connector.p2.y },
        });
    } else {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x - 18, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x - 18, y: connector.p1.y + 8 },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y },
            p2: { x: connector.p2.x, y: connector.p2.y },
        });
    }

    return lines;
}

// SVG path for connectors to tables
// { M 0 0 }, { L 20 8 }, { L 0 16 }
function getSymbolManyLines(connector, direction) {
    const lines = [];

    if (direction === RIGHT) {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x + 20, y: connector.p1.y },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x + 20, y: connector.p1.y },
            p2: { x: connector.p1.x, y: connector.p1.y + 8 },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y },
            p2: { x: connector.p2.x, y: connector.p2.y },
        });
    } else {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x - 20, y: connector.p1.y },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x - 20, y: connector.p1.y },
            p2: { x: connector.p1.x, y: connector.p1.y + 8 },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y },
            p2: { x: connector.p2.x, y: connector.p2.y },
        });
    }
    return lines;
}

// SVG path for connectors to tables
// { M 0 0 }, { L 20 8 }, { L 0 16 }
function getSymbolManyNullLines(connector, direction) {
    const lines = [];

    if (direction === RIGHT) {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x + 20, y: connector.p1.y },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x + 20, y: connector.p1.y },
            p2: { x: connector.p1.x, y: connector.p1.y + 8 },
        });

        lines.push({
            type: 'circle',
            p1: { x: connector.p1.x + 20 + 8, y: connector.p1.y },
            pr: { x: connector.p1.x + 20 + 8 + 5, y: connector.p1.y },
            width: 5,
        });
    } else {
        lines.push({
            type: 'circle',
            p1: { x: connector.p1.x - 20 - 8, y: connector.p1.y },
            pr: { x: connector.p1.x + 20 - 8 - 15, y: connector.p1.y },
            width: 5,
        });

        lines.push({
            type: 'line',
            p1: { x: connector.p1.x, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x - 20, y: connector.p1.y },
        });
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x - 20, y: connector.p1.y },
            p2: { x: connector.p1.x, y: connector.p1.y + 8 },
        });
    }
    return lines;
}

function getSymbolOneNullLines(connector, direction) {
    const lines = [];

    if (direction === RIGHT) {
        lines.push({
            type: 'line',
            p1: { x: connector.p1.x + 18, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x + 18, y: connector.p1.y + 8 },
        });

        lines.push({
            type: 'circle',
            p1: { x: connector.p1.x + 20 + 8, y: connector.p1.y },
            pr: { x: connector.p1.x + 20 + 8 + 5, y: connector.p1.y },
            width: 5,
        });
    } else {
        lines.push({
            type: 'circle',
            p1: { x: connector.p1.x - 20 - 8, y: connector.p1.y },
            pr: { x: connector.p1.x + 20 - 8 - 15, y: connector.p1.y },
            width: 5,
        });

        lines.push({
            type: 'line',
            p1: { x: connector.p1.x - 18, y: connector.p1.y - 8 },
            p2: { x: connector.p1.x - 18, y: connector.p1.y + 8 },
        });
    }

    return lines;
}

function buildTableConnectors(
    elementX,
    elementY,
    elementWidth,
    insideElementIndex,
    relationType
) {
    // const CONNECTOR_WIDTH = 14;

    const connectorWidth = ['one-null', 'many-null'].includes(relationType)
        ? CONNECTOR_WIDTH
        : CONNECTOR_WIDTH;

    const midInsideElementY =
        elementY +
        TABLE_HEADER_HEIGHT +
        HEADER_BODY_MARGIN +
        insideElementIndex * TABLE_ROW_HEIGHT +
        TABLE_ROW_HEIGHT / 2;
    const tableConnectors = {
        left: {
            // left table point
            p1: {
                x: elementX,
                y: midInsideElementY,
            },
            // left table + connectorWidth point
            p2: {
                x: elementX - connectorWidth,
                y: midInsideElementY,
            },
            lines: [
                {
                    // left table point
                    p1: {
                        x: elementX,
                        y: midInsideElementY,
                    },
                    // left table + connectorWidth point
                    p2: {
                        x: elementX - connectorWidth + 11,
                        y: midInsideElementY,
                    },
                },
                // {
                // 	// left table point
                // 	p1: {
                // 		x: elementX - connectorWidth,
                // 		y: midInsideElementY,
                // 	},
                // 	// left table + connectorWidth point
                // 	p2: {
                // 		x: elementX - connectorWidth,
                // 		y: midInsideElementY,
                // 	}
                // },
            ],
        },
        right: {
            // right table point
            p1: {
                x: elementX + elementWidth,
                y: midInsideElementY,
            },
            // right table + connectorWidth point
            p2: {
                x: elementX + elementWidth + connectorWidth,
                y: midInsideElementY,
            },
            lines: [
                {
                    // right table point
                    p1: {
                        x: elementX + elementWidth,
                        y: midInsideElementY,
                    },
                    // right table + connectorWidth point
                    p2: {
                        x: elementX + elementWidth + connectorWidth - 11,
                        y: midInsideElementY,
                    },
                },
                // {
                // 	// right table point
                // 	p1: {
                // 		x: elementX + elementWidth + connectorWidth,
                // 		y: midInsideElementY,
                // 	},
                // 	// right table + connectorWidth point
                // 	p2: {
                // 		x: elementX + elementWidth + connectorWidth,
                // 		y: midInsideElementY,
                // 	},
                // }
            ],
        },
    };

    return tableConnectors;
}

function buildEmptyConnectors(mouseX, mouseY) {
    // const CONNECTOR_WIDTH = 14;

    const emptyConnectors = {
        left: {
            // left table point
            p1: {
                x: mouseX,
                y: mouseY,
            },
            // left table + connectorWidth point
            p2: {
                x: mouseX - CONNECTOR_WIDTH,
                y: mouseY,
            },
            lines: [
                {
                    // left table point
                    p1: {
                        x: mouseX,
                        y: mouseY,
                    },
                    // left table + connectorWidth point
                    p2: {
                        x: mouseX - CONNECTOR_WIDTH,
                        y: mouseY,
                    },
                },
            ],
        },
        right: {
            // right table point
            p1: {
                x: mouseX,
                y: mouseY,
            },
            // right table + connectorWidth point
            p2: {
                x: mouseX + CONNECTOR_WIDTH,
                y: mouseY,
            },
            lines: [
                {
                    // right table point
                    p1: {
                        x: mouseX,
                        y: mouseY,
                    },
                    // right table + connectorWidth point
                    p2: {
                        x: mouseX + CONNECTOR_WIDTH,
                        y: mouseY,
                    },
                },
            ],
        },
    };

    return emptyConnectors;
}

function getTablesDirections(t1, t2) {
    const LEFT = 'left';
    const RIGHT = 'right';

    let t1Side;
    let t2Side;

    // compare external points from connectors lines (near = close to table, external = table + connectorWidth)
    const t1ConnectorLeftX = t1.left.p2.x;
    const t1ConnectorRightX = t1.right.p2.x;

    const t2ConnectorLeftX = t2.left.p2.x;
    const t2ConnectorRightX = t2.right.p2.x;

    // logic
    if (t1ConnectorRightX + 20 <= t2ConnectorLeftX) {
        t1Side = RIGHT;
        t2Side = LEFT;
    } else if (t2ConnectorRightX + 20 <= t1ConnectorLeftX) {
        t1Side = LEFT;
        t2Side = RIGHT;
    } else if (
        t1ConnectorLeftX < t2ConnectorLeftX &&
        t1ConnectorRightX > t2ConnectorLeftX
    ) {
        // t1Side = LEFT;
        // t2Side = LEFT;
        t1Side = RIGHT;
        t2Side = RIGHT;
    } else if (
        t1ConnectorLeftX < t2ConnectorRightX &&
        t1ConnectorRightX > t2ConnectorRightX
    ) {
        t1Side = RIGHT;
        t2Side = RIGHT;
    } else {
        // t1Side = LEFT;
        // t2Side = LEFT;
        t1Side = RIGHT;
        t2Side = RIGHT;
    }

    return [t1Side, t2Side];
}
function connect(
    t1Connector,
    t2Connector,
    t1Direction,
    t2Direction,
    t1RelationType,
    t2RelationType
) {
    // left - lefter table connector point
    // right - righter table connector point
    let left;
    let right;

    let isLeftDownRightUp = false;
    const lines = [];
    let points = [];
    let bounds = {};

    let isLeftRight = false;

    // p2.x = 'table.x + connectorWidth' point
    if (t1Connector.p2.x < t2Connector.p2.x) {
        left = t1Connector.p2;
        right = t2Connector.p2;

        isLeftRight = true;
    } else {
        left = t2Connector.p2;
        right = t1Connector.p2;

        isLeftRight = false;
    }

    isLeftDownRightUp = right.y > left.y;

    if (t1Direction === t2Direction) {
        if (t1Direction === 'right') {
            let width = 10;
            let isTurnInverted;
            let centerYDown;
            let centerYUp;
            let centerX = right.x + width;

            if (isLeftDownRightUp) {
                // LEFT DOWN + RIGHT UP
                width = Math.min((right.y - left.y) / 4, 10);
                centerYUp = left.y + width;
                centerYDown = right.y - width;
                isTurnInverted = true;
            } else {
                // LEFT UP + RIGHT DOWN
                width = Math.min((left.y - right.y) / 4, 10);
                centerYUp = left.y - width;
                centerYDown = right.y + width;
                isTurnInverted = false;
            }

            // line: left to left-center
            lines.push({
                type: 'line',
                p1: { x: left.x, y: left.y },
                p2: { x: centerX - width, y: left.y },
            });
            points.push({ x: centerX, y: left.y });

            // angle: left-center to center-up
            lines.push({
                type: 'angle',
                width,
                turn: isTurnInverted ? 1 : 0,
                point: { x: centerX, y: centerYUp },

                p1: { x: centerX, y: left.y },
                p2: { x: centerX, y: centerYUp },
            });
            // line: center-up to center-down
            lines.push({
                type: 'line',
                p1: { x: centerX, y: centerYUp },
                p2: { x: centerX, y: centerYDown },
            });
            points.push({
                x: centerX,
                y: centerYDown + (isTurnInverted ? width : -width),
            });

            // angle: center-down to right-with
            lines.push({
                type: 'angle',
                width,
                turn: isTurnInverted ? 1 : 0,
                point: { x: centerX - width, y: right.y },

                p1: {
                    x: centerX,
                    y: centerYDown + (isTurnInverted ? width : -width),
                },
                p2: { x: right.x, y: right.y },
            });

            if (width < 10) {
                // line: additional line from rigth-with to rigth
                lines.push({
                    type: 'line',
                    p1: { x: right.x, y: right.y },
                    p2: { x: centerX - width, y: right.y },
                });
            }
        } else {
            // TODO: LEFT; LEFT;
            // lines.push({
            // 	type: 'line',
            // 	p1: { x: left.x, y: left.y },
            // 	p2: { x: left.x, y: right.y },
            // });
            // lines.push({
            // 	type: 'line',
            // 	p1: { x: left.x, y: right.y },
            // 	p2: { x: right.x, y: right.y },
            // });
        }
    } else if (left.x !== right.x) {
        // LEFT UP + RIGHT DOWN
        const centerX = left.x + (right.x - left.x) / 2;
        let width;
        let isTurnInverted;
        let centerXLeft;
        let centerXRight;
        let centerYDown;
        let centerYUp;

        if (isLeftDownRightUp) {
            // LEFT DOWN + RIGHT UP
            width = Math.min((right.y - left.y) / 4, 10);
            centerXLeft = centerX - width;
            centerXRight = centerX + width;
            centerYDown = right.y - width;
            centerYUp = left.y + width;
            isTurnInverted = true;
        } else {
            // LEFT UP + RIGHT DOWN
            width = Math.min((left.y - right.y) / 4, 10);
            centerXLeft = centerX - width;
            centerXRight = centerX + width;
            centerYDown = left.y - width;
            centerYUp = right.y + width;
            isTurnInverted = false;
        }

        // line: left to left-center
        lines.push({
            type: 'line',
            p1: { x: left.x, y: left.y },
            p2: { x: centerXLeft, y: left.y },
        });
        points.push({ x: centerX, y: left.y });
        points.push({ x: centerX, y: right.y });

        // angle: left-center to center-down
        lines.push({
            type: 'angle',
            width,
            turn: isTurnInverted ? 1 : 0,
            point: {
                x: centerX,
                y: isLeftDownRightUp ? centerYUp : centerYDown,
            },

            p1: { x: centerXLeft + width, y: left.y },
            p2: { x: centerX, y: centerYUp },
        });

        if (isLeftDownRightUp) {
            // line: center-down to center-up
            lines.push({
                type: 'line',
                p1: { x: centerX, y: centerYUp },
                p2: { x: centerX, y: centerYDown },
            });
        } else {
            // line: center-down to center-up
            lines.push({
                type: 'line',
                p1: { x: centerX, y: centerYDown },
                p2: { x: centerX, y: centerYUp },
            });
        }
        // angle: center-up to right-center
        lines.push({
            type: 'angle',
            width,
            turn: isTurnInverted ? 0 : 1,
            point: { x: centerXRight, y: right.y },

            p1: { x: centerXRight - width, y: right.y },
            p2: { x: right.x, y: right.y },
        });
        // line: right-center to right
        lines.push({
            type: 'line',
            p1: { x: centerXRight, y: right.y },
            p2: { x: right.x, y: right.y },
        });
    } else {
        // line: left to right
        lines.push({
            type: 'line',
            p1: { x: left.x, y: left.y },
            p2: { x: right.x, y: right.y },
        });
    }

    // const connectorsLines = [
    // 	{
    // 		type: 'line',
    // 		p1: t1Connector.p1,
    // 		p2: t1Connector.p2,
    // 	},
    // 	{
    // 		type: 'line',
    // 		p1: t2Connector.p1,
    // 		p2: t2Connector.p2,
    // 	},
    // ]
    const connectorsLines = [
        {
            type: 'line',
            p1: t1Connector.lines[0].p1,
            p2: t1Connector.lines[0].p2,
            // p2: t1Connector.p2,
        },
        {
            type: 'line',
            p1: t2Connector.lines[0].p1,
            p2: t2Connector.lines[0].p2,
            // p1: t2Connector.p1,
            // p2: t2Connector.p2,
        },
    ];

    let firstConnectorLine;
    let lastConnectorLine;

    if (isLeftRight) {
        firstConnectorLine = connectorsLines[0];
        lastConnectorLine = connectorsLines[1];
    } else {
        firstConnectorLine = connectorsLines[1];
        lastConnectorLine = connectorsLines[0];
    }

    points = [firstConnectorLine.p1, ...points, lastConnectorLine.p1];

    const firstConnectorSymbolLines = getConnectorSymbolLines(
        t1Connector,
        t1RelationType,
        t1Direction
    );
    const lastConnectorSymbolLines = getConnectorSymbolLines(
        t2Connector,
        t2RelationType,
        t2Direction
    );

    const fullPath = [
        firstConnectorLine,
        ...firstConnectorSymbolLines,
        ...lines,
        lastConnectorLine,
        ...lastConnectorSymbolLines,
    ];

    bounds = {
        minX: Math.min(firstConnectorLine.p1.x, lastConnectorLine.p1.x),
        maxX: Math.max(firstConnectorLine.p1.x, lastConnectorLine.p1.x),
        minY: Math.min(firstConnectorLine.p1.y, lastConnectorLine.p1.y),
        maxY: Math.max(firstConnectorLine.p1.y, lastConnectorLine.p1.y),
    };

    const connectorsLinesCounts = [
        firstConnectorSymbolLines.length + 1,
        lastConnectorSymbolLines.length + 1,
    ];
    return [fullPath, points, bounds, connectorsLinesCounts];
}

// function drawNewLine() {
// 	const ctx = contextRef.current;

// 	ctx.strokeStyle = '#e6e6e6'; // Колір лінії
// 	// ctx.strokeStyle = '#A1ADBA'; // Колір лінії
// 	ctx.lineWidth = 2.5; // Товщина лінії

// 	// TODO: separete on table to table and table to empty
// 	if (newRelationLineFromRef.current.elementType === 'table') {

// 		if (newRelationLineToRef.current.elementId) {
// 			// build two connectors lines for tables (line from table.x to table.x + connectorWidth)
// 			const t1Connectors = buildTableConnectors(newRelationLineFromRef.current);
// 			const t2Connectors = buildTableConnectors(newRelationLineToRef.current);

// 			// compare connectors between two tables to get right directions between tables (left or right), which side of the table will be connect line to the table
// 			const [t1Direction, t2Direction] = getTablesDirections(t1Connectors, t2Connectors);

// 			// select one connector (left or right) for each table
// 			const t1Connector = t1Connectors[t1Direction];
// 			const t2Connector = t2Connectors[t2Direction];

// 			const lines = connect(t1Connector, t2Connector, t1Direction, t2Direction);

// 			ctx.beginPath();
// 			lines.forEach(({ type, p1, p2, width }) => {
// 				if (type === 'line') {
// 					ctx.moveTo(p1.x, p1.y);
// 					ctx.lineTo(p2.x, p2.y);
// 				} else if (type === 'angle') {
// 					// // Для арки на канвасі треба обчислити додаткові параметри
// 					// const radius = width;
// 					// const startAngle = 0; // Початковий кут, тут можна підлаштувати
// 					// const endAngle = Math.PI; // Кінцевий кут, тут можна підлаштувати
// 					// const anticlockwise = turn ? true : false;

// 					// // Визначимо центр дуги, в даному випадку це point.x та point.y
// 					// ctx.arc(point.x, point.y, radius, startAngle, endAngle, anticlockwise);

// 					const radius = width;
// 					// const startX = p1.x;
// 					// const startY = p1.y;
// 					// const endX = point.x;
// 					// const endY = point.y;

// 					// // Використаємо arcTo для побудови дуги
// 					// context.moveTo(startX, startY);
// 					ctx.arcTo(p1.x, p1.y, p2.x, p2.y, radius);
// 					// ctx.arcTo(150, 20, 150, 70, 50);

// 				}
// 			});
// 			ctx.stroke();
// 		} else {

// 			// build two connectors lines for tables (line from table.x to table.x + connectorWidth)
// 			const t1Connectors = buildTableConnectors(newRelationLineFromRef.current);
// 			const t2Connectors = buildEmptyConnectors(newRelationLineToRef.current.x, newRelationLineToRef.current.y);

// 			// compare connectors between two tables to get right directions between tables (left or right), which side of the table will be connect line to the table
// 			const [t1Direction, t2Direction] = getTablesDirections(t1Connectors, t2Connectors);

// 			// select one connector (left or right) for each table
// 			const t1Connector = t1Connectors[t1Direction];
// 			const t2Connector = t2Connectors[t2Direction];

// 			const lines = connect(t1Connector, t2Connector, t1Direction, t2Direction);

// 			ctx.beginPath();
// 			lines.forEach(({ type, p1, p2, width }) => {
// 				if (type === 'line') {
// 					ctx.moveTo(p1.x, p1.y);
// 					ctx.lineTo(p2.x, p2.y);
// 				} else if (type === 'angle') {
// 					// // Для арки на канвасі треба обчислити додаткові параметри
// 					// const radius = width;
// 					// const startAngle = 0; // Початковий кут, тут можна підлаштувати
// 					// const endAngle = Math.PI; // Кінцевий кут, тут можна підлаштувати
// 					// const anticlockwise = turn ? true : false;

// 					// // Визначимо центр дуги, в даному випадку це point.x та point.y
// 					// ctx.arc(point.x, point.y, radius, startAngle, endAngle, anticlockwise);

// 					const radius = width;
// 					// const startX = p1.x;
// 					// const startY = p1.y;
// 					// const endX = point.x;
// 					// const endY = point.y;

// 					// // Використаємо arcTo для побудови дуги
// 					// context.moveTo(startX, startY);
// 					ctx.arcTo(p1.x, p1.y, p2.x, p2.y, radius);
// 					// ctx.arcTo(150, 20, 150, 70, 50);

// 				}
// 			});
// 			ctx.stroke();

// 		}

// 	}

// 	const fromElement = elementsRef.current[newRelationLineFromRef.current.elementId];
// 	// const fromInsideElement = elementFrom.value.columns[newRelationLineFromRef.current.insideElementId];
// 	const fromInsideElementIndex = newRelationLineFromRef.current.insideElementIndex;

// 	const fromPointX = fromElement.x;// + fromElement.width;
// 	const fromPointY = fromElement.y + TABLE_HEADER_HEIGHT + HEADER_BODY_MARGIN + fromInsideElementIndex * TABLE_ROW_HEIGHT + TABLE_ROW_HEIGHT / 2;

// 	if (newRelationLineToRef.current.elementId && newRelationLineToRef.current.insideElementId) {
// 		// path for column to column
// 		// const toElement = elementsRef.current[newRelationLineToRef.current.elementId];
// 		// // const toInsideElement = elementFrom.value.columns[newRelationLineToRef.current.insideElementId];
// 		// const toInsideElementIndex = newRelationLineToRef.current.insideElementIndex;

// 		// // TODO: continue from here
// 		// // const relationLineObject = buildRelationLineObject(newRelationLineFromRef.current, newRelationLineToRef.current);

// 		// let toPointX = toElement.x + toElement.width;
// 		// const toPointY = toElement.y + TABLE_HEADER_HEIGHT + HEADER_BODY_MARGIN + toInsideElementIndex * TABLE_ROW_HEIGHT + TABLE_ROW_HEIGHT / 2;

// 		// if (newRelationLineToRef.current.x < toElement.x + toElement.width * 0.3) {
// 		// 	toPointX = toElement.x;
// 		// }
// 		// 20%
// 		// const toDirection =
// 		// you have fromPointX, if fromPointX nearer to the toElement.x than to (toElement.x + toElement.width)
// 		// get logic from relation lines component

// 		// Почати новий шлях (path)
// 		// ctx.beginPath();
// 		// ctx.moveTo(fromPointX, fromPointY); // Початкова точка A
// 		// ctx.lineTo(toPointX, toPointY); // Кінцева точка B
// 		// ctx.stroke();       // Намалювати лінію

// 	} else {
// 		// path from column to space
// 		// Почати новий шлях (path)
// 		ctx.beginPath();
// 		ctx.moveTo(fromPointX, fromPointY); // Початкова точка A
// 		ctx.lineTo(newRelationLineToRef.current.x, newRelationLineToRef.current.y); // Кінцева точка B
// 		ctx.stroke();       // Намалювати лінію

// 	}

// 	ctx.fillStyle = 'rgba(0, 0, 255, 0.05)';
// 	// ctx.fillStyle = 'rgba(179, 194, 255, 0.2)';
// 	ctx.fillRect(newRelationLineFromRef.current.x, newRelationLineFromRef.current.y, newRelationLineToRef.current.x - newRelationLineFromRef.current.x, newRelationLineToRef.current.y - newRelationLineFromRef.current.y);
// 	// ctx.strokeStyle = 'cornflowerblue';
// 	ctx.strokeStyle = 'rgb(0, 0, 255)';
// 	// ctx.lineWidth = 0.5;
// 	ctx.lineWidth = scaleNumbersRef.current.outlineWidth;
// 	ctx.strokeRect(selectionStartXYRef.current.x, selectionStartXYRef.current.y, selectionCurrentXYRef.current.x - selectionStartXYRef.current.x, selectionCurrentXYRef.current.y - selectionStartXYRef.current.y);

// }

function _buildLinePath(lineData) {
    const {
        mouseX,
        mouseY,

        fromElementType,
        fromElementWidth,
        fromElementX,
        fromElementY,
        fromInsideElementIndex,
        fromRelationType,

        toElementType,
        toElementWidth,
        toElementX,
        toElementY,
        toInsideElementIndex,
        toRelationType,
    } = lineData;

    // TODO: separete on table to table and table to empty
    if (fromElementType === 'table') {
        if (toElementType) {
            // build two connectors lines for tables (line from table.x to table.x + connectorWidth)
            const t1Connectors = buildTableConnectors(
                fromElementX,
                fromElementY,
                fromElementWidth,
                fromInsideElementIndex,
                fromRelationType
            );
            const t2Connectors = buildTableConnectors(
                toElementX,
                toElementY,
                toElementWidth,
                toInsideElementIndex,
                toRelationType
            );

            // compare connectors between two tables to get right directions between tables (left or right), which side of the table will be connect line to the table
            const [t1Direction, t2Direction] = getTablesDirections(
                t1Connectors,
                t2Connectors
            );

            // select one connector (left or right) for each table
            const t1Connector = t1Connectors[t1Direction];
            const t2Connector = t2Connectors[t2Direction];

            const [lines, points, bounds, connectorsLinesCounts] = connect(
                t1Connector,
                t2Connector,
                t1Direction,
                t2Direction,
                fromRelationType,
                toRelationType
            );

            return [lines, points, bounds, connectorsLinesCounts];
        } else {
            // build two connectors lines for tables (line from table.x to table.x + connectorWidth)
            const t1Connectors = buildTableConnectors(
                fromElementX,
                fromElementY,
                fromElementWidth,
                fromInsideElementIndex,
                fromRelationType
            );
            const t2Connectors = buildEmptyConnectors(mouseX, mouseY);

            // compare connectors between two tables to get right directions between tables (left or right), which side of the table will be connect line to the table
            const [t1Direction, t2Direction] = getTablesDirections(
                t1Connectors,
                t2Connectors
            );

            // select one connector (left or right) for each table
            const t1Connector = t1Connectors[t1Direction];
            const t2Connector = t2Connectors[t2Direction];

            const [lines, points, bounds, connectorsLinesCounts] = connect(
                t1Connector,
                t2Connector,
                t1Direction,
                t2Direction,
                fromRelationType,
                toRelationType
            );

            return [lines, points, bounds, connectorsLinesCounts];

            // ctx.beginPath();
            // lines.forEach(({ type, p1, p2, width }) => {
            // 	if (type === 'line') {
            // 		ctx.moveTo(p1.x, p1.y);
            // 		ctx.lineTo(p2.x, p2.y);
            // 	} else if (type === 'angle') {
            // 		// // Для арки на канвасі треба обчислити додаткові параметри
            // 		// const radius = width;
            // 		// const startAngle = 0; // Початковий кут, тут можна підлаштувати
            // 		// const endAngle = Math.PI; // Кінцевий кут, тут можна підлаштувати
            // 		// const anticlockwise = turn ? true : false;

            // 		// // Визначимо центр дуги, в даному випадку це point.x та point.y
            // 		// ctx.arc(point.x, point.y, radius, startAngle, endAngle, anticlockwise);

            // 		const radius = width;
            // 		// const startX = p1.x;
            // 		// const startY = p1.y;
            // 		// const endX = point.x;
            // 		// const endY = point.y;

            // 		// // Використаємо arcTo для побудови дуги
            // 		// context.moveTo(startX, startY);
            // 		ctx.arcTo(p1.x, p1.y, p2.x, p2.y, radius);
            // 		// ctx.arcTo(150, 20, 150, 70, 50);

            // 	}
            // });
            // ctx.stroke();
        }
    }
}
function _drawLinePath(
    ctx,
    path,
    isLineHighlighted,
    isLineFocused,
    isNewLine,
    outlineWidth,
    solidType = 'solid',
    colorValue
) {
    // ctx.strokeStyle =
    // 	isLineHighlighted || isLineFocused || isNewLine
    // 		? 'cornflowerblue'
    // 		: '#e6e6e6';
    const color =
        isLineHighlighted || isLineFocused || isNewLine
            ? // ? 'cornflowerblue'
            //   '#6f94ff'
            'rgba(119, 160, 255, 1)'
            // ((colorValue === 'blue') ? 'rgba(147, 179, 255, 1)' : 'rgba(119, 160, 255, 1)')

            : colorValue
                ? getLineColor(colorValue)
                : '#dadada'; // : '#e6e6e6';

    ctx.strokeStyle = color;

    ctx.fillStyle = null;
    // ctx.lineWidth = isLineHighlighted || isLineFocused || isNewLine
    // 	// ? 3.3
    // 	? 3.2
    // 	: 2.5;

    ctx.lineWidth =
        isLineHighlighted || isLineFocused || isNewLine
            ? // ? outlineWidth + 0.5
            // : outlineWidth + 0.2;
            // ? outlineWidth + 0.5 + 0.2 // ASAP LAST
            outlineWidth + 0.3
            : outlineWidth + 0.3;

    ctx.lineCap = 'round';

    if (solidType === 'dashes') {
        ctx.setLineDash([12, 15]);
    } else if (solidType === 'dots') {
        ctx.setLineDash([0.5, 6]);
    } else {
        ctx.setLineDash([]);
    }

    if (!path[0]) {
        console.log('er path: ', path);
    }

    const firstConnector = path[0].slice(0, path[3][0]);
    const mainPath = path[0].slice(path[3][0], path[0].length - path[3][1]);
    const lastConnector = path[0].slice(-path[3][1]);

    // full path
    ctx.beginPath();
    mainPath.forEach(({ type, p1, p2, pr, width }) => {
        if (type === 'line') {
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
        } else if (type === 'angle') {
            const radius = width;
            ctx.arcTo(p1.x, p1.y, p2.x, p2.y, radius);
        } else if (type === 'circle') {
            const radius = width;
            // ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
            if (pr) {
                ctx.moveTo(pr.x, pr.y);
            }
            ctx.arc(p1.x, p1.y, radius, 0, 2 * Math.PI);
        }
    });
    ctx.stroke();
    ctx.setLineDash([]);

    // connectors
    ctx.beginPath();
    [...firstConnector, ...lastConnector].forEach(
        ({ type, p1, p2, pr, width }) => {
            if (type === 'line') {
                ctx.moveTo(p1.x, p1.y);
                ctx.lineTo(p2.x, p2.y);
            } else if (type === 'angle') {
                const radius = width;
                ctx.arcTo(p1.x, p1.y, p2.x, p2.y, radius);
            } else if (type === 'circle') {
                const radius = width;
                // ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
                if (pr) {
                    ctx.moveTo(pr.x, pr.y);
                }
                ctx.arc(p1.x, p1.y, radius, 0, 2 * Math.PI);
            }
        }
    );

    ctx.stroke();

    if (isLineFocused) {
        // const radius = 3.5;
        // const radius = 4;
        // const radius = 5.25;
        const radius = 4.25;

        // ctx.shadowColor = 'cornflowerblue';
        // ctx.shadowBlur = 2; // Розмиття тіні
        // ctx.shadowOffsetX = 0; // Зміщення по горизонталі
        // ctx.shadowOffsetY = 0; // Зміщення по вертикалі

        // ctx.lineWidth = 1.75;
        // ctx.lineWidth = 1.5;
        ctx.lineWidth = 2.75;
        ctx.lineWidth = 2.25;

        ctx.strokeStyle = 'cornflowerblue';
        // ctx.beginPath();

        for (let i = 0; i < path[1].length - 1; i++) {
            const x1 = path[1][i].x;
            const y1 = path[1][i].y;

            const x2 = path[1][i + 1].x;
            const y2 = path[1][i + 1].y;

            const x = (x1 + x2) / 2;
            const y = (y1 + y2) / 2;

            ctx.beginPath();
            ctx.fillStyle = 'white';
            ctx.fillStyle = null;

            ctx.strokeStyle = 'rgba(119, 160, 255, 1)';

            ctx.arc(x, y, radius, 0, 2 * Math.PI); // Малюємо коло
            ctx.fill();
            ctx.stroke();
        }
        // path[1].forEach(({ x, y }) => {
        // 	ctx.beginPath();
        // 	ctx.fillStyle = 'red';
        // 	ctx.strokeStyle = 'cornflowerblue';

        // 	ctx.arc(x, y, radius, 0, 2 * Math.PI); // Малюємо коло
        // 	ctx.fill();
        // 	ctx.stroke();
        // });
        // ctx.fill();
        ctx.fillStyle = null;
    }

    // if (isLineHighlighted || isLineFocused || isNewLine) {
    // 	ctx.shadowColor = 'cornflowerblue';
    // 	ctx.shadowBlur = 2; // Розмиття тіні
    // 	ctx.shadowOffsetX = 0; // Зміщення по горизонталі
    // 	ctx.shadowOffsetY = 0; // Зміщення по вертикалі

    // 	ctx.lineWidth = 3;
    // 	ctx.strokeStyle = 'cornflowerblue';
    // 	ctx.beginPath();
    // 	path[0].forEach(({ type, p1, p2, width }) => {
    // 		if (type === 'line') {
    // 			ctx.moveTo(p1.x, p1.y);
    // 			ctx.lineTo(p2.x, p2.y);
    // 		} else if (type === 'angle') {
    // 			const radius = width;
    // 			ctx.arcTo(p1.x, p1.y, p2.x, p2.y, radius);
    // 		}
    // 	});
    // 	ctx.stroke();

    // }
    // if (fromElementId) {
    // 	// const [fromPoints, toPoints] = getLinePoints(fromElementId, fromInsideElementId, toElementId, toInsideElementId);
    // 	// const lines = buildLines(fromPoints, toPoints);
    // 	// drawLines();

    // } else if (lines) {

    // 	ctx.beginPath();
    // 	lines.forEach(({ type, p1, p2, width }) => {
    // 		if (type === 'line') {
    // 			ctx.moveTo(p1.x, p1.y);
    // 			ctx.lineTo(p2.x, p2.y);
    // 		} else if (type === 'angle') {
    // 			// // Для арки на канвасі треба обчислити додаткові параметри
    // 			// const radius = width;
    // 			// const startAngle = 0; // Початковий кут, тут можна підлаштувати
    // 			// const endAngle = Math.PI; // Кінцевий кут, тут можна підлаштувати
    // 			// const anticlockwise = turn ? true : false;

    // 			// // Визначимо центр дуги, в даному випадку це point.x та point.y
    // 			// ctx.arc(point.x, point.y, radius, startAngle, endAngle, anticlockwise);

    // 			const radius = width;
    // 			// const startX = p1.x;
    // 			// const startY = p1.y;
    // 			// const endX = point.x;
    // 			// const endY = point.y;

    // 			// // Використаємо arcTo для побудови дуги
    // 			// context.moveTo(startX, startY);
    // 			ctx.arcTo(p1.x, p1.y, p2.x, p2.y, radius);
    // 			// ctx.arcTo(150, 20, 150, 70, 50);

    // 		}
    // 	});
    // 	ctx.stroke();

    // } else {
    // 	// Почати новий шлях (path)
    // 	ctx.beginPath();
    // 	ctx.moveTo(from.x, from.y); // Початкова точка A
    // 	ctx.lineTo(to.x, to.y); // Кінцева точка B
    // 	ctx.stroke();       // Намалювати лінію
    // }
}

export { _buildLinePath, _drawLinePath };
